import { render, staticRenderFns } from "./topicThree.vue?vue&type=template&id=d5d56d04&scoped=true&"
import script from "./topicThree.vue?vue&type=script&lang=js&"
export * from "./topicThree.vue?vue&type=script&lang=js&"
import style0 from "./topicThree.vue?vue&type=style&index=0&id=d5d56d04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d56d04",
  null
  
)

export default component.exports